var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42.535,
    height: 29.323,
    viewBox: "0 0 42.535 29.323",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "youtube",
    d: "M129.264,8.42a6.11,6.11,0,0,0-6.14-6.073q-7.258-.3-14.84-.282-7.576-.014-14.842.282A6.112,6.112,0,0,0,87.3,8.42c-.2,2.654-.291,5.31-.284,7.964s.081,5.994.284,8.648A6.112,6.112,0,0,0,93.441,31.1q7.261.3,14.842.282,7.576.014,14.84-.282a6.11,6.11,0,0,0,6.14-6.073c.205-2.654.293-5.994.284-8.648.009-2.654-.079-5.31-.284-7.964m-25.44,14.423v-12.3l11.06,6.181Z",
    transform: "translate(-87.014 -2.065)",
    fill: "#2ca17f"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.6b16134950366796346cebb886b4ffe8.svg";
export { ForwardRef as ReactComponent };